import { Quote } from 'lucide-react';

export default function AboutFounder() {
    return (
        <section className="py-20 bg-gradient-to-br from-slate-50 via-orange-50 to-amber-50">
            <div className="container mx-auto px-4">
                <div className="max-w-4xl mx-auto">
                    {/* Section Header */}
                    <div className="text-center mb-12">
                        <h2 className="text-orange-900 mb-3">Message from Founder</h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-red-600 mx-auto rounded-full"></div>
                    </div>

                    {/* Message Card */}
                    <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 relative border-t-4 border-orange-500">
                        {/* Quote Icon */}
                        <div className="absolute -top-6 left-8 bg-gradient-to-br from-orange-500 to-red-600 rounded-full p-4 shadow-lg">
                            <Quote className="w-6 h-6 text-white" />
                        </div>

                        {/* Message Content */}
                        <div className="space-y-6 text-gray-700 leading-relaxed">
                            <p>
                                With over <span className="font-bold text-orange-700">11 years of experience</span> and <span className="font-bold text-orange-700">7000+ in-depth chart analysis</span>—including work with founders, sportspersons, Olympians, film industry professionals, and business leaders—I have seen astrology at its best when it is used responsibly and thoughtfully.
                            </p>

                            <p>
                                At Mova Astro, astrology is not about fear, superstition, or fixed predictions. It is a structured system for understanding patterns—both within ourselves and in life—so we can make clearer, more conscious decisions.
                            </p>

                            <p>
                                My own journey with astrology began as a search for clarity during uncertain phases of life. Over time, I learned that Vedic astrology, when applied with integrity, becomes a tool for self-awareness rather than dependency. This belief defines our approach at Mova Astro.
                            </p>

                            <p>
                                We combine the depth of ancient Vedic wisdom with modern, practical thinking to offer ethical, personalized guidance. Whether you are in India or anywhere in the world, our intention is simple: to help you move forward with clarity and confidence.
                            </p>

                            <p className="italic text-gray-600">
                                Thank you for trusting us.
                            </p>
                        </div>

                        {/* Founder Signature */}
                        <div className="mt-10 pt-8 border-t-2 border-orange-100">
                            <div className="flex items-center gap-4">
                                {/* Avatar Placeholder */}
                                <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center shadow-lg">
                                    <span className="text-white text-2xl font-bold">PS</span>
                                </div>
                                {/* Founder Info */}
                                <div>
                                    <p className="text-gray-900 mb-1">
                                        <span className="font-bold text-xl">Preet Singh</span>
                                    </p>
                                    <p className="text-orange-700 font-semibold">Founder, Mova Astro</p>
                                    <p className="text-sm text-gray-500 mt-1">Vedic Astrologer | 11+ Years Experience</p>
                                </div>
                            </div>
                        </div>

                        {/* Decorative Sanskrit */}
                        <div className="text-center mt-8">
                            <p className="text-orange-600 text-sm font-semibold">
                                सत्यं वद । धर्मं चर
                            </p>
                            <p className="text-gray-500 text-xs italic mt-1">
                                Speak the truth. Walk the path of righteousness.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
